/*
 * File: alert.ts
 * File Created: 2024-01-02 09:26:03
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-10-16 10:46:39
 * Modified By: Val Liu
 * -----
 */

import { VariantType } from "@root/components/base-classes";
import FloatingAlert from "@root/components/utilities/floating-alert/floating-alert";
import { Vue } from "vue-property-decorator";

type AlertCallback = { (message?: string, type?: VariantType): void };

interface IAlertConfig {
    title: string;
    message: string;
}

declare module "vue/types/vue" {
    export interface Vue {
        $alert(message: string, type?: VariantType): AlertCallback | null;
        $alert(config: IAlertConfig, type?: VariantType): AlertCallback | null;
    }
}

const floatingAlertContainer = new Vue({
    render: (h) => h(FloatingAlert),
}).$mount();
const floatingAlertInstance: FloatingAlert = floatingAlertContainer.$children[0] as any;

export const AlertPlugin = {
    install: function (Vue: any) {
        if (Vue._val_alert_installed) return;
        Vue._val_alert_installed = true;

        Vue.mixin({
            methods: {
                /// control the modal popup
                $alert: function (
                    this: Vue,
                    config: any,
                    type?: VariantType,
                ): AlertCallback | null {
                    const app = document.body;
                    if (app == null) {
                        console.error("<AlertPlugin> cannot find body.");
                        return null;
                    }
                    /// lazy mount
                    const el = floatingAlertContainer.$el;
                    const parentEl = el.parentElement;
                    if (parentEl == null || parentEl !== app) {
                        app.appendChild(el);
                    }

                    let message: string | null = null;
                    if (typeof config === "string") message = config;
                    else {
                        const { title, message: msg } = config;
                        message = `<h4>${title}</h4>${msg}`;
                    }

                    const obj = floatingAlertInstance.addAlert({ message, type });

                    return (message?: string, type?: VariantType) => {
                        let alert = { ...obj };
                        if (message != null) alert.message = message;
                        if (type != null) alert.type = type;

                        floatingAlertInstance.setAlert(alert);
                    };
                },
            },
        });
    },
};
